module.exports = __webpack_public_path__ + "welcome.svg?b1c713869b3d794f3bc6ac761d3b123f";